module.exports = __webpack_public_path__ + "img/lianghao.829671fa.png";